module.exports = __webpack_public_path__ + "static/media/Surg image 2.c9f6c6ff.png";